// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2HoIf","colBig":"styles_colBig__2AFLK","colSmall":"styles_colSmall__19lNl"};